import { useState, useEffect } from 'react';
import { CountryCode } from '@dayetopia/library/types';

export function useGeolocationCountryCode(shouldFetch: boolean = true) {
  const [geolocationCountryCode, setGeolocationCountryCode] = useState<CountryCode | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!shouldFetch) return;
    const url = `https://extreme-ip-lookup.com/json/?key=${process.env.EXTREME_KEY}`;
    fetch(url)
      .then((res) => res.json())
      .then((json) => {
        if (!json.countryCode) return;

        setGeolocationCountryCode(json.countryCode);
      })
      .catch((e: Error) => {
        console.warn('extreme-ip-lookup failed: ', e);
        setError(e?.message);
      });
  }, [shouldFetch]);

  return { geolocationCountryCode, error };
}
